// extracted by mini-css-extract-plugin
export default {"container":"Section_container__Bel2b","header":"Section_header__uLx6p","label":"Section_label__5i06B","actionText":"Section_actionText__f-rQK"};